export default [
  {
    name: 'DroneView',
    path: '/drone/:droneId/view',
    props: true,
    component: () => import('./View.vue'),
  },
];
